// @flow

// libs
import React from 'react'
import getContent from 'pp-react-l10n'
import get from 'lodash/get'
import glamorous from 'glamorous'
import { IconInfoLarge } from 'components'

// other
import clientData from 'utils/client-data'
import type { RouterHistory } from 'react-router'
import { withRouter } from 'react-router-dom'
const l10n = getContent('pages/error')

const SubHeader = glamorous.p({
  fontSize: 15,
  color: '#2c2e2f',
  textAlign: 'center',
  width: 300,
})

const Header = glamorous.div({
  fontSize: '30px',
  fontWeight: '300',
  color: '#2c2e2f',
  textAlign: 'center',
})

type Props = {
  history: RouterHistory,
  slug?: string,
  error?: string,
}

type State = {
  slug: string,
}

class ErrorScreen extends React.Component<Props, State> {
  static defaultProps = {
    slug: get(clientData, 'slugDetails.userPayPalMeDetails.slug'),
  }

  getButtonText = () => {
    const error = get(this.props, 'history.location.state.error')

    if (error) {
      return l10n(`error.button.${error}`)
    }

    return l10n('error.button.try')
  }

  buttonAction = () => {
    return this.props.history.goBack()
  }

  render() {
    const errorKey =
      this.props.error ||
      get(this.props, 'history.location.state.error', 'generic')

    const errorTitle =
      this.props.error ||
      get(this.props, 'history.location.state.error', 'header')

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <IconInfoLarge color="#ff9600" />
        <Header css={{ marginTop: 36 }}>
          {l10n(`error.title.${errorTitle}`)}
        </Header>
        <SubHeader css={{ marginTop: 36 }}>
          {l10n(`error.subheader.${errorKey}`)}
        </SubHeader>
        <a
          onClick={this.buttonAction}
          style={{ marginTop: 36, width: '80%' }}
          className="vx_btn"
        >
          {this.getButtonText()}
        </a>
      </div>
    )
  }
}

export default withRouter(ErrorScreen)
